'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getHCodelistsRefsInData = exports.getHCodelistsRefs = undefined;

var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _ramda = require('ramda');

var R = _interopRequireWildcard(_ramda);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getHCodelistsRefs = exports.getHCodelistsRefs = function getHCodelistsRefs(annotations) {
  return R.reduce(function (acc, annotation) {
    if (annotation.type !== 'HIER_CONTEXT') {
      return acc;
    }
    var references = annotation.text || annotation.title || '';
    var refs = R.pipe(R.split(','), R.reduce(function (acc2, ref) {
      var match = ref.match(/([\w@_.]+):([\w@_.]+):([\w@_.]+)\(([\d.]+)\).([\w@_.]+)$/);
      if (R.isNil(match)) {
        return acc2;
      }

      var _R$tail = R.tail(match),
          _R$tail2 = (0, _slicedToArray3.default)(_R$tail, 5),
          codelistId = _R$tail2[0],
          agencyId = _R$tail2[1],
          code = _R$tail2[2],
          version = _R$tail2[3],
          hierarchy = _R$tail2[4];

      return R.assoc(codelistId, { agencyId: agencyId, code: code, version: version, hierarchy: hierarchy, codelistId: codelistId }, acc2);
    }, {}))(references);
    return R.mergeRight(acc, refs);
  }, {}, annotations);
};

var getHCodelistsRefsInData = exports.getHCodelistsRefsInData = function getHCodelistsRefsInData(sdmxJson) {
  var annotations = R.pathOr([], ['data', 'structure', 'annotations'], sdmxJson);
  return getHCodelistsRefs(annotations);
};